import { api, mApi } from "@/lib/api";

/** Unwrap admin `{ code, message, data }` or return flat merchant/admin payloads. */
export function unwrapData(response) {
  const body = response?.data;
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    (Object.prototype.hasOwnProperty.call(body, "code") ||
      Object.prototype.hasOwnProperty.call(body, "message"))
  ) {
    return body.data;
  }
  return body;
}

export function explorerBase(network) {
  const n = String(network || "").toLowerCase();
  if (n.includes("test") || n === "chapel") return "https://testnet.bscscan.com";
  return "https://bscscan.com";
}

export function txUrl(hash, network) {
  if (!hash || !String(hash).startsWith("0x")) return null;
  return `${explorerBase(network)}/tx/${hash}`;
}

export function addressUrl(address, network) {
  if (!address) return null;
  return `${explorerBase(network)}/address/${address}`;
}

export const USDT_CONTRACT = {
  mainnet: "0x55d398326f99059fF775485246999027B3197955",
  testnet: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
};

export function tokenContractForNetwork(network) {
  const n = String(network || "").toLowerCase();
  if (n.includes("test") || n === "chapel") return USDT_CONTRACT.testnet;
  return USDT_CONTRACT.mainnet;
}

/* —— Merchant portal —— */

export async function fetchMerchantWallet() {
  const r = await mApi.get("/merchant/wallet");
  return unwrapData(r);
}

export async function fetchMerchantCryptoDeposits({ page = 1, limit = 25 } = {}) {
  const r = await mApi.get("/merchant/crypto/deposits", { params: { page, limit } });
  const data = unwrapData(r) || {};
  return {
    items: data.items ?? [],
    total: data.total ?? 0,
    pages: data.pages ?? data.total_pages ?? 0,
  };
}

/* —— Admin —— */

export async function fetchCryptoStats() {
  const r = await api.get("/admin/crypto/stats");
  return unwrapData(r);
}

export async function fetchCryptoWallets(params = {}) {
  const r = await api.get("/admin/crypto/wallets", { params });
  const data = unwrapData(r) || {};
  return {
    items: data.items ?? [],
    total: data.total ?? 0,
    page: data.page ?? 1,
    limit: data.limit ?? 50,
    pages: data.total_pages ?? data.pages ?? 0,
  };
}

export async function inspectCryptoWallet(address) {
  const r = await api.get(`/admin/crypto/wallets/${encodeURIComponent(address)}`);
  return unwrapData(r);
}

export async function fetchCryptoDeposits(params = {}) {
  const r = await api.get("/admin/crypto/deposits", { params });
  const data = unwrapData(r) || {};
  return {
    items: data.items ?? [],
    total: data.total ?? 0,
    page: data.page ?? 1,
    limit: data.limit ?? 50,
    pages: data.total_pages ?? data.pages ?? 0,
  };
}

export async function manualCryptoSweep(wallet_address, credit_deposit = true) {
  const r = await api.post("/admin/crypto/manual-sweep", { wallet_address, credit_deposit });
  return unwrapData(r);
}

export async function retryCryptoDeposit(tx_hash) {
  const r = await api.post("/admin/crypto/retry-deposit", { tx_hash });
  return unwrapData(r);
}

export async function syncCryptoWebhooks() {
  const r = await api.post("/admin/crypto/sync-webhooks");
  return unwrapData(r);
}

export async function reconcileCrypto() {
  const r = await api.get("/admin/crypto/reconcile");
  return unwrapData(r);
}
